// packages/web/src/api/trip-declarations/keys.ts

export const tripKeys = {
  all: ["trip-declarations"] as const,
  inbox: (userId: string) => [...tripKeys.all, "inbox", userId] as const,
  detail: (id: string) => [...tripKeys.all, id] as const,
};
